import { z } from "zod";

import { LAST_CONTACT_OPTIONS } from "../constants/reengage.constants";

const REQUIRED = "list.reengage.requiredField";

const OptionItemSchema = z.object({
	id: z.union([z.string(), z.number()]),
	title: z.string(),
});

export type ReengageOptionItem = z.infer<typeof OptionItemSchema>;

const lastContactValues = LAST_CONTACT_OPTIONS.map((o) => o.id) as [string, ...string[]];

export const ReengageSourceFormSchema = z
	.object({
		name: z.string().min(1, { message: REQUIRED }).trim(),
		fromLists: z.array(OptionItemSchema),
		bestSentiment: z.array(OptionItemSchema),
		lastContact: z.enum(lastContactValues),
		lastContactRange: z.object({ from: z.string(), till: z.string() }).nullable(),
		companyCategory: z.array(OptionItemSchema),
		personaCategory: z.array(OptionItemSchema),
		leadScore: z.array(OptionItemSchema),
		companyHqLocation: z.array(OptionItemSchema),
		personalLocation: z.array(OptionItemSchema),
	})
	.refine(
		(v) => v.lastContact !== "custom" || (!!v.lastContactRange?.from && !!v.lastContactRange?.till),
		{
			path: ["lastContactRange"],
			message: REQUIRED,
		}
	);

export type ReengageSourceFormValues = z.infer<typeof ReengageSourceFormSchema>;

export const emptyReengageForm = (name = ""): ReengageSourceFormValues => ({
	name,
	fromLists: [],
	bestSentiment: [],
	lastContact: "3m",
	lastContactRange: null,
	companyCategory: [],
	personaCategory: [],
	leadScore: [],
	companyHqLocation: [],
	personalLocation: [],
});
